import React, { useEffect, useRef, useState } from "react"
import { Helmet } from "react-helmet"
import Header from "../components/Header"
import SideNav from "../components/SideNav"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import BusinessMetrics from "../components/BusinessMetrics"
import DashboardCounts from "../components/DashboardCounts"
import Bills from "../components/Bills"
import CommissionReceived from "../components/CommissionReceived"
import ExpenditureAndInterest from "../components/ExpenditureAndInterest"
import TargetSavingsMetrics from "../components/TargetSavingsMetrics"
import PosMetrics from "../components/PosMetrics"
import TransactionMetrics from "../components/TransactionMetrics"
import BalanceMetrics from "../components/BalanceMetrics"
import TotalBalance from "../components/TotalBalance"
import Balance from "../components/Balance"
import { BASE_API_URL } from "../constants/dropdown"

const HomeScreen = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const refs = useRef(true)
  const [searchCustomerId, setSearchCustomerId] = useState("")
  const [selectedCustomerId, setSelectedCustomerId] = useState("")
  const [selectedCustomerName, setSelectedCustomerName] = useState("")
  const [isSearchingCustomer, setIsSearchingCustomer] = useState(false)
  const [customerSearchMessage, setCustomerSearchMessage] = useState("")
  const [restrictionType, setRestrictionType] = useState(0)
  const [liftRestriction, setLiftRestriction] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const admin2faLogin = useSelector((state) => state.admin2faLogin)
  const { userInfo } = admin2faLogin

  useEffect(() => {
    // if (!userInfo || userInfo === null) {
    //   navigate('/', { replace: true })
    // }
    if (
      userInfo?.user?.role === "Account Officer" ||
      userInfo?.user?.role === "DSA"
    ) {
      navigate(`/officer/${userInfo?.user?.id}`, { replace: true })
    } else if (userInfo?.user?.role === "TREEGAR") {
      navigate("/treegar", { replace: true })
    }

    if (refs.current) {
      // dispatch(fundsLocked())
      // dispatch(totalTransfer())

      refs.current = false
    }
  }, [dispatch, userInfo, navigate])

  useEffect(() => {
    const raw = (searchCustomerId ?? "").toString().trim()
    const token = userInfo?.token?.access_token

    if (!raw) {
      setSelectedCustomerId("")
      setSelectedCustomerName("")
      setCustomerSearchMessage("")
      setIsSearchingCustomer(false)
      return
    }

    if (!token) {
      setCustomerSearchMessage("SESSION EXPIRED. PLEASE LOG IN AGAIN")
      return
    }

    const isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    const isAccountNumber = (value) => /^\d+$/.test(value)
    const isTag = (value) => /^[a-zA-Z0-9_]+$/.test(value) && /\d/.test(value)

    let queryKey = "customername"
    if (isEmail(raw)) {
      queryKey = "customeremail"
    } else if (isAccountNumber(raw)) {
      queryKey = "accountnumber"
    } else if (isTag(raw)) {
      queryKey = "customertag"
    }

    const timerId = setTimeout(async () => {
      try {
        setIsSearchingCustomer(true)
        setCustomerSearchMessage("Searching customer...")

        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }

        const { data } = await axios.get(
          `${BASE_API_URL}/admin/customer/all?${queryKey}=${encodeURIComponent(raw)}&size=1`,
          config,
        )

        const foundCustomer = data?.items?.[0]
        if (!foundCustomer?.id) {
          setSelectedCustomerId("")
          setSelectedCustomerName("")
          setCustomerSearchMessage("No customer found")
          return
        }

        setSelectedCustomerId(String(foundCustomer.id))
        setSelectedCustomerName(
          foundCustomer?.customer_name ||
            foundCustomer?.user_name ||
            foundCustomer?.customer_email ||
            "",
        )
        setCustomerSearchMessage("Customer selected")
      } catch (error) {
        setSelectedCustomerId("")
        setSelectedCustomerName("")
        setCustomerSearchMessage(
          error?.response?.data?.message || "No customer found",
        )
      } finally {
        setIsSearchingCustomer(false)
      }
    }, 400)

    return () => clearTimeout(timerId)
  }, [searchCustomerId, userInfo])

  const handleRestrictionSubmit = async (event) => {
    event.preventDefault()

    const parsedCustomerId = Number(selectedCustomerId)
    if (
      !selectedCustomerId ||
      Number.isNaN(parsedCustomerId) ||
      parsedCustomerId <= 0
    ) {
      toast.error("SEARCH AND SELECT A CUSTOMER ID FIRST", {
        position: toast.POSITION.TOP_RIGHT,
      })
      return
    }

    try {
      setIsSubmitting(true)

      const token = userInfo?.token?.access_token
      if (!token) {
        toast.error("SESSION EXPIRED. PLEASE LOG IN AGAIN", { position: toast.POSITION.TOP_RIGHT })
        setIsSubmitting(false)
        return
      }
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }

      const pndBlockEndpoint = `${BASE_API_URL}/admin/customer/pnd-block`
      const payload = {
        customer_id: parsedCustomerId,
        type: Number(restrictionType),
        lift_restriction: liftRestriction,
      }

      const { data } = await axios.post(pndBlockEndpoint, payload, config)

      toast.success(data?.message || "REQUEST SUBMITTED SUCCESSFULLY", {
        position: toast.POSITION.TOP_RIGHT,
      })
    } catch (error) {
      toast.error(error?.response?.data?.message || "FAILED TO SUBMIT REQUEST", {
        position: toast.POSITION.TOP_RIGHT,
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <ToastContainer />
      <SideNav />
      <Helmet>
        <title>
          {" "}
          Admin Dashboard | PennyTree - Lifestyle and Finance are not Mutually
          Exclusive
        </title>
      </Helmet>
      <section className="page-container ">
        <div className="page-content">
          <Header />
          <div className="page-body">
            <div className="accordion restriction-panel-accordion" id="restrictionPanelAccordion">
              <div className="restriction-panel accordion-item">
                <h3 className="accordion-header" id="restrictionPanelHeader">
                  <button
                    className="accordion-button restriction-panel__toggle"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#restrictionPanelCollapse"
                    aria-expanded="true"
                    aria-controls="restrictionPanelCollapse"
                  >
                    Restriction Controls
                  </button>
                </h3>
                <div
                  id="restrictionPanelCollapse"
                  className="accordion-collapse collapse show"
                  aria-labelledby="restrictionPanelHeader"
                >
                  <div className="accordion-body restriction-panel__accordion-body">
                    <form
                      className="restriction-panel__body"
                      onSubmit={handleRestrictionSubmit}
                    >
                      <div className="restriction-panel__search-block">
                        <label
                          className="form-label restriction-panel__label"
                          htmlFor="customerIdSearch"
                        >
                          Customer Search
                        </label>
                        <input
                          id="customerIdSearch"
                          type="text"
                          className="form-control restriction-panel__search-input"
                          value={searchCustomerId}
                          onChange={(event) => setSearchCustomerId(event.target.value)}
                          placeholder="TYPE CUSTOMER ID / TAG / EMAIL / NAME"
                        />
                        <p className="restriction-panel__selected-customer">
                          Selected:{" "}
                          <span>{selectedCustomerName || "NONE"}</span>
                        </p>
                        {customerSearchMessage && (
                          <p className="restriction-panel__message">
                            {customerSearchMessage}
                          </p>
                        )}
                      </div>

                      <div className="restriction-panel__controls">
                        <div className="restriction-panel__field">
                          <label
                            className="form-label restriction-panel__label"
                            htmlFor="restrictionType"
                          >
                            Restriction Type
                          </label>
                          <select
                            id="restrictionType"
                            className="form-select restriction-panel__select"
                            value={restrictionType}
                            onChange={(event) =>
                              setRestrictionType(Number(event.target.value))
                            }
                          >
                            <option value={0}>PND</option>
                            <option value={1}>BLOCK</option>
                          </select>
                        </div>
                        <div className="restriction-panel__field restriction-panel__field--center">
                          <div className="form-check restriction-panel__check">
                            <input
                              id="liftRestriction"
                              type="checkbox"
                              className="form-check-input"
                              checked={liftRestriction}
                              onChange={(event) =>
                                setLiftRestriction(event.target.checked)
                              }
                            />
                            <label
                              className="form-check-label restriction-panel__check-label"
                              htmlFor="liftRestriction"
                            >
                              Lift Restriction
                            </label>
                          </div>
                        </div>
                        <div className="restriction-panel__field restriction-panel__field--end">
                          <button
                            type="submit"
                            className="restriction-panel__submit"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <h1 className="">Dashboard Overview</h1>

            <div className="row">
              <div className="col-lg-12">
                <div className="accordion" id="dashboardAccordion">
                  <Balance />
                  <TotalBalance />
                  <TargetSavingsMetrics />
                  <PosMetrics />
                  <BusinessMetrics />
                  <BalanceMetrics />
                  <DashboardCounts />
                  <TransactionMetrics />
                  <Bills />

                  <CommissionReceived />
                  <ExpenditureAndInterest />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default HomeScreen
